// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lighthouse"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6 22C6 22 8 15 8 10V3H16V10C16 15 18 22 18 22H14L13 18H11L10 22H6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 2V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V2M16 6H8M8 3H16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 9.99805H12.0039V10.002H12V9.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lighthouse')
export default class LighthouseIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lighthouse',
    }
  }
}
